/* Index commun issu des collections Shopify publiées. Relu à chaque navigation,
   sans liste de produits ou de pays à maintenir dans le JavaScript. */
(function () {
  'use strict';
  if (window.MDMCataloguePays) return;
  var script = document.currentScript;
  var url = script && script.dataset.url;
  if (!url) return;
  function cle(s) { return String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function lire(page) {
    return fetch(url + '&page=' + page).then(function (r) { if (!r.ok) throw new Error('Catalogue indisponible'); return r.json(); });
  }
  var ready = lire(1).then(function (d) {
    var suite = [];
    for (var i = 2; i <= d.pages; i++) suite.push(lire(i));
    return Promise.all(suite).then(function (pages) {
      var collections = d.collections.concat.apply(d.collections, pages.map(function (p) { return p.collections; }));
      var uniques = {};
      collections.forEach(function (c) {
        if (!c.pays || !(c.nb > 0)) return;
        var k = cle(c.nom), precedent = uniques[k];
        if (!precedent || cle(c.handle) === k || (cle(precedent.handle) !== k && c.nb > precedent.nb)) uniques[k] = c;
      });
      return { pays: Object.keys(uniques).map(function (k) { return uniques[k]; }).sort(function (a,b) { return a.nom.localeCompare(b.nom,document.documentElement.lang); }), collections: collections };
    });
  }).catch(function () { return null; });
  window.MDMCataloguePays = { ready: ready, cle: cle };

  function familleCle(s) {
    var k=cle(s);
    if(/^commemoratives?noncirculantes?/.test(k))return 'nc';
    if(/^series?(?:\d{4})?$/.test(k))return 'serie';
    return k;
  }
  function famille(p, type) {
    var tags = (p.tags || []).map(cle), types = (p.types || []).map(cle);
    if (type === 'monde') return true;
    var deux = tags.some(function(s){return s==='type2euro'||s==='2euro';}) || types.some(function (s) { return s.indexOf('2euro') >= 0; });
    var serie = tags.some(function(s){return s==='typeserie'||s==='serie'||s==='series';}) || types.some(function (s) { return s.indexOf('serie') >= 0; });
    var nc = tags.some(function(s){return s==='typenc'||s.indexOf('noncirculante')>=0;}) || types.some(function (s) { return s.indexOf('noncirculante') >= 0; });
    return type === '2euro' ? deux : type === 'serie' ? serie : type === 'euro' ? deux || serie || nc : type === 'nc' ? nc : true;
  }
  function paysFamille(data,type) {
    return data.pays.filter(function(p){return famille(p,type);}).map(function(p){
      var collection=data.collections.find(function(c){
        if(!(c.nb>0))return false;
        var n=cle(c.handle),sansPrefixe=n;
        if(type==='2euro')sansPrefixe=n.replace(/^2euros?/,'');
        else if(type==='serie')sansPrefixe=n.replace(/^series?/,'');
        else if(type==='nc')sansPrefixe=n.replace(/^commemoratives?noncirculantes?/,'');
        return sansPrefixe!==n&&sansPrefixe===cle(p.nom);
      });
      return collection?Object.assign({},p,{url:collection.url,nb:collection.nb}):p;
    });
  }
  function liens(liste, pays, modele) {
    var frag = document.createDocumentFragment();
    pays.forEach(function (p) {
      var li = document.createElement('li'), a = document.createElement('a'), nom = document.createElement('span');
      a.href = p.url; nom.className = 'nav-nom'; nom.textContent = p.nom;
      if (p.forme) a.insertAdjacentHTML('beforeend', p.forme);
      a.appendChild(nom); li.appendChild(a); frag.appendChild(li);
    });
    liste.replaceChildren(frag);
  }
  function zone(p) {
    var c = cle(p.continent);
    if (c.indexOf('amerique') === 0) return 'amerique';
    return ['europe','afrique','asie','oceanie'].indexOf(c) >= 0 ? c : 'autres';
  }
  function monde(mega, pays) {
    var boutons = mega.querySelector('.mega__continents'), panneaux = mega.querySelector('.mega__panneaux');
    if (!boutons || !panneaux) return;
    var modele = mega.cloneNode(true), groupes = {}, premier = true;
    pays.forEach(function (p) { var z = zone(p); (groupes[z] || (groupes[z] = [])).push(p); });
    boutons.replaceChildren(); panneaux.replaceChildren();
    var labels = document.documentElement.lang === 'en' ? ['Europe','Africa','Americas','Asia','Oceania','Other countries'] : ['Europe','Afrique','Amérique','Asie','Océanie','Autres pays'];
    ['europe','afrique','amerique','asie','oceanie','autres'].forEach(function (z,i) {
      if (!groupes[z]) return;
      var li=document.createElement('li'), b=document.createElement('button'), panel=document.createElement('div'), h=document.createElement('h4'), ul=document.createElement('ul');
      b.type='button'; b.dataset.continent='auto-'+z; b.textContent=labels[i]; b.className=premier?'actif':'';
      b.setAttribute('aria-pressed',premier?'true':'false'); b.setAttribute('aria-controls',mega.id+'-auto-'+z);
      panel.className='mega__panneau-pays'+(premier?' actif':''); panel.dataset.panneau='auto-'+z; panel.id=mega.id+'-auto-'+z;
      h.textContent=labels[i]; ul.className='mega__pays mega__pays--monde'; liens(ul,groupes[z],modele);
      li.appendChild(b); boutons.appendChild(li); panel.appendChild(h); panel.appendChild(ul); panneaux.appendChild(panel); premier=false;
    });
  }
  function annees(racine, type, data) {
    var entree=racine.querySelector(':scope > a,:scope > .tiroir__liens > .tiroir__tout');
    var base = data.collections.find(function (c) { return entree ? c.url===entree.getAttribute('href') : familleCle(c.handle)===type; });
    if (!base) return;
    var years = (base.tags || []).filter(function (t) { return /^(?:annee:)?\d{4}$/.test(t); }).map(function (t) { return t.slice(-4); }).filter(function(y,i,a){return a.indexOf(y)===i;}).sort().reverse();
    if (!years.length) return;
    racine.querySelectorAll('.mega__annees,.tiroir__annees').forEach(function (ul) {
      ul.replaceChildren();
      years.forEach(function (year) {
        var li=document.createElement('li'), a=document.createElement('a'); a.textContent=year; a.href=base.url+'?annee='+year; li.appendChild(a); ul.appendChild(li);
      });
    });
  }
  function preparerGroupes(entree, mobile) {
    var cible=mobile?entree.querySelector('.tiroir__liens'):entree.querySelector('.mega:not(.mega--monde) .mega__grille');
    if(!cible||cible.querySelector(mobile?'.tiroir__pays':'.mega__col--pays'))return;
    var tout=mobile&&cible.querySelector('.tiroir__tout'),edito=!mobile&&cible.querySelector('.mega__edito');
    cible.replaceChildren();if(tout)cible.appendChild(tout);
    ['annees','pays'].forEach(function(n){
      var col=mobile?cible:document.createElement('div'),h=document.createElement(mobile?'span':'h4'),ul=document.createElement('ul');
      if(!mobile)col.className='mega__col mega__col--'+n;
      h.textContent=n==='annees'?(document.documentElement.lang==='en'?'Year':'Millésime'):(document.documentElement.lang==='en'?'Country':'Pays');
      if(mobile)h.className='sous-groupe';ul.className=(mobile?'tiroir__':'mega__')+n;
      col.appendChild(h);col.appendChild(ul);if(!mobile)cible.appendChild(col);
    });
    if(edito)cible.appendChild(edito);
    if(!mobile)cible.style.gridTemplateColumns='minmax(0,1fr) minmax(0,2fr)'+(edito?' var(--mg-edito-w,250px)':'');
  }
  function appliquer(data) {
    if (!data) return;
    document.querySelectorAll('.nav__item[data-catalogue-famille]').forEach(function (entree) {
      var type=familleCle(entree.dataset.catalogueFamille), modele=entree.cloneNode(true);
      if (type==='monde') { var mega=entree.querySelector('.mega--monde'); if (mega) monde(mega,data.pays); }
      else {preparerGroupes(entree,false);entree.querySelectorAll('.mega__col--pays .mega__pays').forEach(function (ul) { liens(ul,paysFamille(data,type),modele); });}
      annees(entree,type,data);
    });
    document.querySelectorAll('.tiroir details[data-catalogue-famille]').forEach(function (entree) {
      var type=familleCle(entree.dataset.catalogueFamille), modele=entree.cloneNode(true);
      if (type==='monde') {
        var cont=entree.querySelector('.tiroir__liens'), tout=cont.querySelector('.tiroir__tout'); cont.replaceChildren(); if(tout)cont.appendChild(tout);
        var groupes={};data.pays.forEach(function(p){var z=zone(p);(groupes[z]||(groupes[z]=[])).push(p);});
        Object.keys(groupes).forEach(function(z){var label=document.createElement('span'),ul=document.createElement('ul');label.className='sous-groupe';label.textContent=z==='autres'?'Autres pays':z.charAt(0).toUpperCase()+z.slice(1);ul.className='tiroir__pays';liens(ul,groupes[z],modele);cont.appendChild(label);cont.appendChild(ul);});
      } else {preparerGroupes(entree,true);entree.querySelectorAll('.tiroir__pays').forEach(function(ul){liens(ul,paysFamille(data,type),modele);});}
      annees(entree,type,data);
    });
  }
  function demarrer() { ready.then(appliquer); }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',demarrer);else demarrer();
  document.addEventListener('shopify:section:load',demarrer);
})();
